import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { browserHistory } from 'react-router';

import { localize } from 'react-localize-redux';
import { connect } from 'react-redux';

import Auth from 'j-toker';
import Lottie from 'react-lottie';
import successAnimationData from 'assets/success.json';

import FlatButton from 'material-ui/FlatButton';
import TextField from '@material-ui/core/TextField';
import { MdCheckCircle as SuccessIcon } from 'react-icons/md';
import { MdWarning as WarningIcon } from 'react-icons/md';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import LanguageOptionsCentered from 'components/shared/LanguageOptionsCentered';

const StyledButton = styled(FlatButton)`
  margin: 20px 0 0 0 !important;
  width: 100%;
  color: ${colors.WHITE} !important;
  fontsize: 16px;
  height: 50px !important;
  background-color: ${(props) =>
    props.disabled ? colors.DISABLED_GRAY : AccentColor()} !important;
`;

const StyledCard = styled(Card)`
  color: ${colors.DARKEST_GRAY} !important;
  font-family: 'Circular', sans-serif !important;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  padding: 15px;
  margin-top: 15px;
`;

const defaultAnimationOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

let Login = connect((store) => {
  return {
    userType: store.userTypes.loginAuth,
    landlordId: store.userTypes.landlordId,
    accountProviderIsSSO: store.userTypes.accountProviderIsSSO,
  };
})(
  class PasswordReset extends Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        first_name: '',
        last_name: '',
        username: '',
        password: '',
        errorMessage: null,
        isButtonEnabled: true,
        hasSentPasswordReset: false,
      };
    }

    handleInputChange = (event) => {
      this.setState({ [event.target.name]: event.target.value.trim() });
    };

    register = () => {
      if (this.state.username === '') return;
      this.setState({ isButtonEnabled: false });
      const auth = Auth;
      Auth.requestPasswordReset({
        email: this.state.username,
        config: this.props.userType,
        landlord_id: this.props.landlordId,
        language_code: getCurrentLocale(),
      })
        .then((response) => {
          auth.configDfd = null;
          this.setState({
            isButtonEnabled: true,
            hasSentPasswordReset: true,
            errorMessage: (
              <p style={{ color: 'green', textAlign: 'left', maxWidth: '290px' }}>
                <SuccessIcon /> {getTranslatedString('passwordResetSuccess')}
              </p>
            ),
          });
        })
        .catch((error) => {
          auth.configDfd = null;
          const errorMessage = {
            errorMessage: (
              <p style={{ textAlign: 'left', maxWidth: '290px' }}>
                <WarningIcon /> {getTranslatedString('unknownError')}
              </p>
            ),
          };
          this.setState({ isButtonEnabled: true, ...errorMessage });
          console.error(error);
        });
    };

    getUrlForUserType = (userType) => {
      if (userType === 'landlord') return '/companies';
      if (userType === 'maintenance') return '/maintenance';
      return '/';
    };

    render() {
      if (this.props.accountProviderIsSSO === true && this.props.userType === 'landlord') {
        browserHistory.push('/companies');
        return null;
      }

      const isButtonEnabled = this.state.isButtonEnabled;
      const loginUrl = this.getUrlForUserType(this.props.userType);

      return (
        <div style={{ marginTop: '20px', maxWidth: '320px', minWidth: '300px' }}>
          <StyledCard>
            <CardContent style={{ padding: '0 0 10px' }}>
              {this.state.hasSentPasswordReset ? (
                <PasswordResetSent
                  email={this.state.username}
                  buttonCallback={() => browserHistory.push(loginUrl)}
                  enterDifferentEmailCallback={() => this.setState({ hasSentPasswordReset: false })}
                />
              ) : (
                <SendPasswordResetForm
                  errorMessage={this.errorMessage}
                  handleInputChange={this.handleInputChange}
                  username={this.state.username}
                  register={this.register}
                  isButtonEnabled={isButtonEnabled}
                  backToLoginUrl={loginUrl}
                />
              )}
              <LanguageOptionsCentered />
            </CardContent>
          </StyledCard>
        </div>
      );
    }
  }
);

const PasswordResetSent = ({ email, buttonCallback, enterDifferentEmailCallback }) => (
  <Fragment>
    <Lottie options={defaultAnimationOptions} height={150} width={150} ariaRole="image" />
    <div>
      <h3 style={{ padding: '0 0 10px' }}>{getTranslatedString('success')}</h3>
      {getTranslatedString('passwordResetSuccessEmail', {
        email: email,
      })}
    </div>
    <div className="row" style={{ textAlign: 'left' }}>
      <StyledButton
        name="submit"
        label={getTranslatedString('passwordReset.backToLogin')}
        primary={true}
        onClick={buttonCallback}
        labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
      />
      <div id="account-links-container">
        <p className="account-link">
          <button type="button" className="link-button" onClick={enterDifferentEmailCallback}>
            {getTranslatedString('enterDifferentEmail')}
          </button>
        </p>
      </div>
    </div>
  </Fragment>
);

const SendPasswordResetForm = ({
  errorMessage,
  handleInputChange,
  username,
  register,
  isButtonEnabled,
  backToLoginUrl,
}) => {
  return (
    <div>
      <h3 style={{ padding: '0 0 10px' }}>{getTranslatedString('passwordReset.passwordReset')}</h3>
      <div className="error-message">{errorMessage}</div>
      <div className="row" style={{ textAlign: 'left' }}>
        <TextField
          name="username"
          label={getTranslatedString('email')}
          inputProps={{ 'aria-label': getTranslatedString('email') }}
          onChange={handleInputChange}
          value={username}
          variant="outlined"
          style={{ marginTop: '5px' }}
        />
      </div>
      <StyledButton
        name="submit"
        label={getTranslatedString('passwordReset.reset')}
        primary={true}
        onClick={register}
        disabled={!isButtonEnabled}
        labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
      />
      <div id="account-links-container">
        <p className="account-link">
          <a href={backToLoginUrl}>{getTranslatedString('passwordReset.backToLogin')}</a>
        </p>
      </div>
    </div>
  );
};

export default localize()(Login);
